import React from 'react';
import PropTypes from 'prop-types';
import { ModalBody as ReactModalBody } from 'reactstrap';
import { Typography } from "../../index";
import './modal.scss';

export const ModalBody = ({
    alignText,
    branded,
    children,
}) => {

    const modalBodyClasses = [
        `bsw-modal-body`,
    ].join(' ');

    return (<>{children 
        ? <ReactModalBody
            className={modalBodyClasses}
        >
            {children &&
                <Typography
                    color={branded ? "$color-secondary-a1" : null}
                    type="body-03"
                    tag="div"
                    textAlign={alignText}
                    responsive
                >
                    {children}
                </Typography>
            }
        </ReactModalBody>
        : null
    }</>
    );
}
